import { createFileRoute } from "@tanstack/react-router";
import { pageHead } from "@/components/site/seo-copy";
import { CategoryPage } from "@/components/site/CategoryPage";
import { categoryBySlug } from "@/components/site/seo";

const category = categoryBySlug("sdr-jobs")!;

export const Route = createFileRoute("/sdr-jobs")({
  head: () => pageHead("/sdr-jobs"),
  component: () => <CategoryPage category={category} />,
});
